import React from "react";
import { useNavigate } from "react-router-dom";
import CommonNavbar from "../../Common/CommonLayout/CommonNavbar";
import { ToastContainer } from "react-toastify";
import { Card, Form, Row, Col, Container, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { API_URL } from "../../../Constant";

const ConfirmAndPay = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  // Optional: If state is not available, you can redirect or render a fallback UI.
  if (!state) {
    navigate("/");
    return null;
  }

  const { counsellorName, counsellorId, selectedSlotDate, slotTime } = state;

  console.log(
    "values of state are: " +
      counsellorName +
      " " +
      counsellorId +
      " " +
      selectedSlotDate +
      " " +
      slotTime
  );

  const makePayment = async () => {
   
    const requestBody = {
      ClientId: parseInt(localStorage.getItem("loginId")),
      CounselorId: parseInt(counsellorId),
      AppointmentDate: selectedSlotDate, // "yyyy-MM-dd"
      AppointmentTime: slotTime.split('-')[0].trim(), // "HH:mm" (24-hour)
      Duration: 60, // 60 minutes
      AppointmentStatus: "pending",
    };
    // alert(JSON.stringify(requestBody))

    try {
      const response = await fetch(`${API_URL}api/appointments/book`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (response.ok) {
        console.log("Payment successful:", data);
        navigate("/client/PaymentConfirmed", {
          state: {
            counsellorName: counsellorName,
            appointmentDate: data.appointment.appointmentDate,
            appointmentTime: data.appointment.appointmentTime,
            zoomMeetingLink: data.appointment.zoomMeetingLink,
          },
        });
      } else {
        console.error("Payment failed:", data);
      }
    } catch (error) {
      console.error("An error occurred during payment:", error);
    }
  };

  return (
    <>
      <div style={{ paddingBottom: "30px" }}>
        <ToastContainer />
        <CommonNavbar />
        <Container className="d-flex justify-content-center mt-4">
          <Card className="shadow p-4" style={{ maxWidth: "500px", width: "100%" }}>
            <Card.Body>
              <h2 className="text-center">Confirm & Pay</h2>
              <hr />
              <Form style={{ paddingLeft: "40px" }}>
                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Counselor Name:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>{counsellorName}</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Date:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>{selectedSlotDate}</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Time:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>{slotTime}</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Medium:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>Zoom Meeting</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Meeting Duration:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>60 min</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={7}>
                      <Form.Label>
                        <b>Amount:</b>
                      </Form.Label>
                    </Col>
                    <Col xs={5}>
                      <Form.Label>0$</Form.Label>
                    </Col>
                  </Row>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Row className="d-flex align-items-center">
                    <Col xs={12} style={{ marginLeft: "30px" }}>
                      <Form.Check type="checkbox" style={{ marginTop: "10px" }} />
                      <Form.Label>
                        By clicking here, I state that I have read and understood the terms and conditions.
                      </Form.Label>
                    </Col>
                  </Row>
                </Form.Group>

                <center>
                  <Button variant="secondary" className="mr-4" onClick={() => navigate(-1)}>
                    Previous
                  </Button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={makePayment}
                  >
                    Make Payment
                  </button>
                </center>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default ConfirmAndPay;
